import type { DashboardWeeklySupplierPerformance } from '../api/dashboardApi';

export const SLOT_COLORS = [
    { headerBg: 'linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%)', headerText: '#c2410c', rateText: '#ea580c' },
    { headerBg: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)', headerText: '#1e40af', rateText: '#2563eb' },
    { headerBg: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)', headerText: '#5b21b6', rateText: '#7c3aed' },
    { headerBg: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)', headerText: '#3730a3', rateText: '#4f46e5' },
    { headerBg: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)', headerText: '#15803d', rateText: '#16a34a' },
    { headerBg: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)', headerText: '#be185d', rateText: '#db2777' },
    { headerBg: 'linear-gradient(135deg, #fef9c3 0%, #fef08a 100%)', headerText: '#a16207', rateText: '#ca8a04' },
    { headerBg: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)', headerText: '#991b1b', rateText: '#dc2626' },
];

export const DEFAULT_SLOT_NAMES = ['아침점심피크', '오후논피크', '저녁피크', '심야논피크'];

// 부릉 하루 기준: 06:00 ~ 익일 05:59
export const getDashboardDate = (): string => {
    const now = new Date();
    if (now.getHours() < 6) {
        now.setDate(now.getDate() - 1);
    }
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const formatNumber = (value?: number): string => {
    if (value === undefined || value === null) return '-';
    return value.toLocaleString();
};

// YYYYMMDD → 요일 반환
export const getWeekdayOnly = (yyyymmdd: string): string => {
    if (!yyyymmdd || yyyymmdd.length !== 8) return '';
    const year = Number(yyyymmdd.slice(0, 4));
    const month = Number(yyyymmdd.slice(4, 6)) - 1;
    const day = Number(yyyymmdd.slice(6, 8));
    const date = new Date(year, month, day);
    const labels = ['일', '월', '화', '수', '목', '금', '토'];
    return labels[date.getDay()];
};

// 주차 범위의 모든 날짜 생성 (YYYYMMDD 형식)
export const generateWeekDates = (startDate: string, endDate: string): string[] => {
    if (!startDate || !endDate) return [];
    const dates: string[] = [];
    const start = new Date(
        Number(startDate.slice(0, 4)),
        Number(startDate.slice(4, 6)) - 1,
        Number(startDate.slice(6, 8)),
    );
    const end = new Date(
        Number(endDate.slice(0, 4)),
        Number(endDate.slice(4, 6)) - 1,
        Number(endDate.slice(6, 8)),
    );
    const current = new Date(start);
    while (current <= end) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, '0');
        const day = String(current.getDate()).padStart(2, '0');
        dates.push(`${year}${month}${day}`);
        current.setDate(current.getDate() + 1);
    }
    return dates;
};

// 슬롯 툴팁 데이터 생성 (target=0 슬롯은 '/' 없이 건수만 반환됨)
export const getSlotTooltipItems = (supplier: DashboardWeeklySupplierPerformance, date: string) => {
    if (!supplier.dailySlots) return null;
    const slots = supplier.dailySlots[date];
    const slotCounts = supplier.dailySlotCounts?.[date];
    if (!slots || slots.length === 0) return null;

    const parseRate = (rateStr: string) => parseInt(rateStr.replace('%', '')) || 0;
    const isNaVal = (v: string) => v === '-';
    const hasTarget = (c: string) => c.includes('/');

    const dateSlotNames = supplier.dailySlotNames?.[date] ?? supplier.slotNames;
    return slots.map((slotRate: string, i: number) => {
        const count = slotCounts?.[i] || '-';
        const noTarget = !isNaVal(count) && !hasTarget(count);
        return {
            label: dateSlotNames?.[i] || `슬롯${i + 1}`,
            rate: slotRate,
            count,
            isAchieved: !isNaVal(slotRate) && !noTarget && parseRate(slotRate) >= 100,
            isNa: isNaVal(slotRate),
            isNoTarget: noTarget,
        };
    });
};
